import React from 'react'
import '../assets/css/Uninstall.css'
import { render } from 'react-dom'
import zhCN from 'antd/lib/locale-provider/zh_CN'
import { ConfigProvider } from 'antd'
import Home from 'src/pc/uninstall/Home'
import CEFTransfer from 'src/commons/utils/CEFTransfer'

CEFTransfer()

render(
  <ConfigProvider locale={zhCN}>
    <Home />
  </ConfigProvider>,
  document.getElementById('root'),
)
